module.exports = __webpack_public_path__ + "static/media/law-document.9a2f2b63.svg";